// @flow
import React, { Component } from 'react';
import type { Element, Node } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'Common/Grid';
import classNames from 'classnames';
import * as Actions from 'actionTypes';
import * as R from 'ramda';
import getFilterBreakdownProp from 'Common/getFilterBreakdownProp';
import { Link } from 'react-router-dom';
import slugify from 'slugify';
import { Helmet } from 'react-helmet';
import styles from 'rootContainer/BrowseAllMakes.scss';

import { getBodyTypesText } from 'Common/formValues';
import Icon from 'Common/Icon';

const toUrl = str => slugify(str).toLowerCase();

export class BrowseAllMakes extends Component<*, *> {
  static mapStateToProps(state: Object): any {
    const pluckFromState = (prop, key) =>
      getFilterBreakdownProp(state, prop, key);
    return {
      makes: pluckFromState('make'),
      category: pluckFromState('category'),
      pagination: state.results.pagination
    };
  }
  makesByLetter: any;

  constructor(props: any) {
    super(props);
    this.state = { letter: 'All' };
    this.makesByLetter = []; // NOTE: it seems to change type later?
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillMount() {
    this.props.dispatch({ type: Actions.FETCH_MAKES });
  }

  setMake: ($letter: any | string) => void = $letter => {
    this.setState({ letter: $letter });
  };

  getMakesByLetter: () => string[] = () => {
    if (this.props.makes) {
      this.makesByLetter = this.props.makes.reduce((rv, x) => {
        (rv[x['key'][0]] = rv[x['key'][0]] || []).push(x);
        return rv;
      }, {});
    }
    return [];
  };

  getAllMake: () => Node[] = () => {
    // NOTE: makesByLetter is a... what?
    return Object.keys(this.makesByLetter).map((value, index) => {
      return this.getMake(value, index);
    });
  };

  getMake: ($letter: any, key?: number) => Node = ($letter, key = null) => {
    return (
      <Row
        key={key}
        className={classNames([
          styles.classBrowseMakeAllRow,
          key ? key % 2 : styles.classBrowseMakeAllRowOdd
        ])}
      >
        <Col colXs={4}>
          <h2>{$letter}</h2>
        </Col>
        <Col colXs={8} className={styles.classBrowseMakeAllCell}>
          {this.makesByLetter[$letter].map((value, index) => {
            return (
              <Link key={index} to={`/used-cars/${toUrl(value['key'])}`}>
                {value['key']}
              </Link>
            );
          })}
        </Col>
      </Row>
    );
  };

  getBodyStyle(): Node {
    return (
      <Row className={classNames([styles.classBrowseMakeAllRow])}>
        <Col colXs={12} className={styles.classBrowseMakeAllCell}>
          {this.props.category
            .filter(
              _ =>
                _.key !== 'other' && _.key !== 'pick up' && _.key !== 'unknown'
            )
            .map((value, index) => {
              return (
                <Link key={index} to={`/used-cars/${toUrl(value['key'])}`}>
                  <div>
                    <Icon iconName={value['key']} size={'large'} />
                    <span className={styles.label}>
                      {getBodyTypesText(value['key'])}
                    </span>
                  </div>
                </Link>
              );
            })}
        </Col>
      </Row>
    );
  }

  render(): Element<*> | null {
    const {
      classBrowseMakeAll,
      classBrowseMakeAllPaging,
      classBrowseMakeAllBodyStyles,
      mtxl,
      mtl
    } = styles;
    if (!this.getMakesByLetter()) {
      return null;
    }

    return (
      <div className={classBrowseMakeAll}>
        <Grid>
          <Helmet>
            <meta name="ROBOTS" content="INDEX,FOLLOW" />
          </Helmet>
          <Row className={mtl}>
            <Col colXs={12}>
              <h1>Browse all stock cars by make</h1>
              <h4>
                What Car? have{' '}
                {this.props.pagination ? this.props.pagination.total : 0} car
                adverts listed for sale today from {this.props.makes.length}{' '}
                manufacturers
              </h4>
            </Col>
          </Row>
          <Row className={mtxl}>
            <Col colXs={12}>
              <div className={classBrowseMakeAllPaging}>
                <span key="all">
                  <a onClick={() => this.setMake('All')}>All</a>
                </span>
                {R.keys(this.makesByLetter).map((key, i) => {
                  return (
                    <span key={i}>
                      <a onClick={() => this.setMake(key)}>{key}</a>
                    </span>
                  );
                })}
              </div>
            </Col>
          </Row>

          <div className={mtxl}>
            {this.state.letter === 'All'
              ? this.getAllMake()
              : this.getMake(this.state.letter)}
          </div>
          <Row className={classNames([mtl, classBrowseMakeAllBodyStyles])}>
            <Col colXs={12}>
              <h1>Browse all body style</h1>
              <div className={mtxl}>{this.getBodyStyle()}</div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

// $FlowFixMe
export default connect(BrowseAllMakes.mapStateToProps)(BrowseAllMakes);



// WEBPACK FOOTER //
// ./src/stockCars/BrowseAllMakes/index.js